import { Box, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { useEffect, useState } from "react";

const NoData = ({displayMsg=''}) => {
    const [message,setMessage] = useState('')
    useEffect(()=>{
           setMessage(displayMsg)
    },[])
    return (
        <Box display="flex" flexDirection="column" alignItems="center" mt={4}>
            <InfoIcon color="primary" sx={{ fontSize: 50 }} />
            <Typography variant="h6" mt={2}>No data</Typography>
            <Typography variant="body2" color="textSecondary" mt={1}>
               {message}
            </Typography>
        </Box>
    )
}

export default NoData;